import 'whatwg-fetch';
import "url-polyfill";
import "babel-polyfill";
import 'es6-promise/auto'
require('es6-object-assign').polyfill();
require('typedarray-slice');